import { Injectable, inject } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import {
  AddEmailErrorMessages,
  AddEmailFormAttributes,
  AddEmailPageContent
} from '@com-delta-idp/mnx-login-ui';
import { LoginHelperUtils } from '../../../utils/login-helper.utils';
import {
  ADD_EMAIL_ERROR_IDS,
  EmailCheckValidator,
  EmailCheckWithConfirmEmailValidator
} from '../../../validator/email-validator';
import { LoginModalContent } from '../../models/aem';

@Injectable({
  providedIn: 'root'
})
export class AddEmailAddressHelperService {
  form!: UntypedFormGroup;
  loginHelperUtils = inject(LoginHelperUtils);

  createForm(): UntypedFormGroup {
    this.form = new UntypedFormGroup({
      email: new UntypedFormControl(null, [EmailCheckValidator]),
      confirmEmail: new UntypedFormControl(null, [
        EmailCheckWithConfirmEmailValidator
      ])
    });
    return this.form;
  }

  getFormGroup(): UntypedFormGroup {
    return this.form;
  }

  getPageContent(aemResponse: LoginModalContent): AddEmailPageContent {
    const { addEmailAddress, pageHeader } = aemResponse;
    return {
      ...addEmailAddress,
      emailLabel: addEmailAddress.enterEmailLabel,
      confirmEmailLabel: addEmailAddress.reEnterEmailLabel,
      pageHeader: {
        ...pageHeader,
        headerTitle: addEmailAddress.headerTitle,
        headerSubTitle: addEmailAddress.headerSubTitle,
        contentBodyHeader: addEmailAddress.contentBodyHeader
      },
      buttonLabel: addEmailAddress.nextDisplayView.button_modal,
      errors: this.getInitialErrorMessage(aemResponse)
    };
  }

  getInitialErrorMessage(
    aemResponse: LoginModalContent
  ): AddEmailErrorMessages {
    const errorMessages: AddEmailErrorMessages = {
      emailErrorMessage: {},
      confirmEmailErrorMessage: {},
      alertWarning: 'To continue, please correct the'
    };
    Object.keys(this.getFormGroup().controls).forEach((controlName: string) => {
      const control = controlName as keyof typeof ADD_EMAIL_ERROR_IDS;
      ADD_EMAIL_ERROR_IDS[control].forEach((errorId: string) => {
        const message = this.loginHelperUtils.getErrorMessageFromAem(
          aemResponse,
          errorId
        );
        const property =
          `${control}ErrorMessage` as keyof AddEmailErrorMessages;
        (errorMessages[property] as Record<string, string>)[errorId] = message;
      });
    });
    return errorMessages;
  }

  getFormAttributes(): AddEmailFormAttributes {
    return {
      errorCount: 0,
      submitAttempt: false,
      errorAlertBanner: false,
      emailControlTouched: false,
      confirmEmailControlTouched: false,
      disableActionButton: false
    };
  }
}
